<div *ngIf="layout!='horizontal'" [formGroup]="formGroup">
  <div class="col-12"><label class="control-label">{{ title }}</label>
     <span *ngIf="tooltipContext" class="p-2"><tooltip [register]="tooltipContext.register" [tab]="tooltipContext.tab" [section]="tooltipContext.section" [field]="tooltipContext.fieldName"></tooltip></span>
  </div>
  <div class="col-12 mt-3">
    <label class="control-label" [ngClass]="{'required': validate}" for="poBoxAddress">PO Box / Address</label>
    <input type="text" maxlength="50" [formControl]="formGroup.controls.address1" class="form-control" id="poBoxAddress" title="PO Box / Address"
           aria-label="PO Box / Address">
    <div class="text-danger" [hidden]="formGroup.controls.address1.valid || !formGroup.controls.address1.touched">
      <small *ngIf="validate && formGroup.controls.address1.hasError('required')">PO Box / Address is required.</small>
    </div>
  </div>
  <div class="col-12 mt-3">
    <label class="control-label" [ngClass]="{'required': validate}" for="suburbCity">Suburb / City</label>
    <input type="text" maxlength="50" [formControl]="formGroup.controls.suburb" class="form-control" id="suburbCity" title="Suburb / City"
           aria-label="Suburb / City">
    <div class="text-danger" [hidden]="formGroup.controls.suburb.valid || !formGroup.controls.suburb.touched">
      <small *ngIf="validate && formGroup.controls.suburb.hasError('required')">Suburb / City is required.</small>
    </div>
  </div>
  <div class="col-12 mt-3">
    <label class="control-label" [ngClass]="{'required': validate}" for="stateTerritory">State / Territory</label>
    <select class="form-control" [formControl]="formGroup.controls.state" title="State / Territory" aria-label="State / Territory">
      <option value="">Please select a state</option>
      <option value="ACT">Australian Capital Territory</option>
      <option value="NSW" selected>New South Wales</option>
      <option value="NT">Northern Territory</option>
      <option value="QLD">Queensland</option>
      <option value="SA">South Australia</option>
      <option value="TAS">Tasmania</option>
      <option value="VIC">Victoria</option>
      <option value="WA">Western Australia</option>
    </select>
    <div class="text-danger" [hidden]="formGroup.controls.state.valid || !formGroup.controls.state.touched">
      <small *ngIf="validate && formGroup.controls.state.hasError('required')">State / Territory is required.</small>
    </div>
  </div>
  <div class="col-12 mt-3">
    <label class="control-label" [ngClass]="{'required': validate}" for="Postcode">Postcode</label>
    <input type="text" maxlength="10" [formControl]="formGroup.controls.postCode" class="form-control" id="Postcode" title="Postcode"
           aria-label="Postcode">
    <div class="text-danger" [hidden]="formGroup.controls.postCode.valid || !formGroup.controls.postCode.touched">
      <small *ngIf="validate && formGroup.controls.postCode.hasError('required')">Postcode is required.</small>
      <small *ngIf="formGroup.controls.postCode.hasError('invalidPostcode')">Postcode must be 4 digits.</small>
    </div>
  </div>
  <div class="col-12 mt-3" *ngIf="!skipCountry">
    <label class="control-label" for="Country">Country</label>
    <input type="text" maxlength="25" [formControl]="formGroup.controls.country" class="form-control" id="Country" title="Country"
           aria-label="Country">
  </div>
</div>
<div *ngIf="layout=='horizontal'" [formGroup]="formGroup">
  <div class="col-12"><label class="control-label">{{ title }}</label>
    <span class="p-2"  *ngIf="tooltipContext"><tooltip [register]="tooltipContext?.register" [tab]="tooltipContext?.tab" [section]="tooltipContext?.section" [field]="tooltipContext?.fieldName"></tooltip></span>
  </div>
  <div class="col-12 mt-3 form-inline">
    <label class="control-label col-3" [ngClass]="{'required': validate}" for="poBoxAddress">PO Box / Address</label>
    <input type="text" maxlength="50" [formControl]="formGroup.controls.address1" class="form-control col-sm-8" id="poBoxAddress" title="PO Box / Address"
           aria-label="PO Box / Address">
    <div class="col-3"></div>
    <div class="text-danger col-sm-8" [hidden]="formGroup.controls.address1.valid || !formGroup.controls.address1.touched">
      <small *ngIf="validate && formGroup.controls.address1.hasError('required')">PO Box / Address is required.</small>
    </div>
  </div>
  <div class="col-12 mt-3 form-inline">
    <label class="control-label col-3" [ngClass]="{'required': validate}" for="suburbCity">Suburb / City</label>
    <input type="text" maxlength="50" [formControl]="formGroup.controls.suburb" class="form-control col-sm-8" id="suburbCity" title="Suburb / City"
           aria-label="Suburb / City">
    <div class="col-3"></div>
    <div class="text-danger col-sm-8" [hidden]="formGroup.controls.suburb.valid || !formGroup.controls.suburb.touched">
      <small *ngIf="validate && formGroup.controls.suburb.hasError('required')">Suburb / City is required.</small>
    </div>
  </div>
  <div class="col-12 mt-3 form-inline">
    <label class="control-label col-3" [ngClass]="{'required': validate}" for="stateTerritory">State / Territory</label>
    <select class="form-control col-sm-8" [formControl]="formGroup.controls.state" title="State / Territory" aria-label="State / Territory">
      <option value="">Please select a state</option>
      <option value="ACT">Australian Capital Territory</option>
      <option value="NSW" selected>New South Wales</option>
      <option value="NT">Northern Territory</option>
      <option value="QLD">Queensland</option>
      <option value="SA">South Australia</option>
      <option value="TAS">Tasmania</option>
      <option value="VIC">Victoria</option>
      <option value="WA">Western Australia</option>
    </select>
    <div class="col-3"></div>
    <div class="text-danger col-sm-8" [hidden]="formGroup.controls.state.valid || !formGroup.controls.state.touched">
      <small *ngIf="validate && formGroup.controls.state.hasError('required')">State / Territory is required.</small>
    </div>

  </div>
  <div class="col-12 mt-3 form-inline">
    <label class="control-label col-3" [ngClass]="{'required': validate}" for="Postcode">Postcode</label>
    <input type="text" maxlength="10" [formControl]="formGroup.controls.postCode" class="form-control col-sm-8" id="Postcode" title="Postcode"
           aria-label="Postcode">
    <div class="col-3"></div>
    <div class="text-danger col-sm-8" [hidden]="formGroup.controls.postCode.valid || !formGroup.controls.postCode.touched">
      <small *ngIf="validate && formGroup.controls.postCode.hasError('required')">Postcode is required.</small>
      <small *ngIf="formGroup.controls.postCode.hasError('invalidPostcode')">Postcode must be 4 digits.</small>
    </div>
  </div>
  <div class="col-12 mt-3 form-inline" *ngIf="!skipCountry">
    <label class="control-label col-3" for="Country">Country</label>
    <input type="text" maxlength="25" [formControl]="formGroup.controls.country" class="form-control col-sm-8" id="Country" title="Country"
           aria-label="Country">
  </div>
</div>

